const settingsConfig = {
    layout          : {
        style : 'layout1', // layout-1 layout-2 layout-3
        config: {} // checkout layout configs at app/fuse-configs/layout-1/Layout1Config.js
    },
    customScrollbars: true,
    // theme           : {
    //     main   : 'greeny',
    //     navbar : 'mainThemeDark',
    //     toolbar: 'mainThemeLight',
    //     footer : 'mainThemeDark'
    // }
    theme           : {
        main   : 'playbook',
        navbar : 'playbook',
        toolbar: 'playbook',
        footer : 'playbook'
    }
};

export default settingsConfig;
